import React from 'react'
import { toJS } from 'mobx'
import ReactDOM from 'react-dom'
import { Provider } from 'mobx-react'
import { AppContainer } from 'react-hot-loader'
import { createStore } from 'mobx-app'
import invoke from 'lodash/invoke'
import forEach from 'lodash/forEach'
import get from 'lodash/get'
import merge from 'lodash/merge'
import reduce from 'lodash/reduce'
import mux from '@expo/mux'
import settings from './common/settings'
import storage from './common/storage'
import stores from './stores'
import appConfig from './apps'
import {IntlProvider, addLocaleData, injectIntl} from 'react-intl'

let config, i18nConfig

//Import lang data
["en", "ru", "sv", "no", "nb", "nn", "da", "fr", "nl", "tr", "pl"].forEach(lang => {
  let localeData = require(`react-intl/locale-data/${lang}`)
  addLocaleData(localeData)
})

const renderActiveApps = (activeApps, apps, state, actions) => {
  forEach(activeApps, ({ mountId, props }, appName) => {

    if( !document.getElementById(mountId) ) {
      console.warn(`No element found with the id ${ mountId } for ${ appName } to mount into.`)
      return true
    }

    const AppComponent = get(apps, appName, false)

    if( !AppComponent ) {
      console.warn(`No app found by the name ${ appName }.`)
      return true
    }

    ReactDOM.render(
      <IntlProvider
        locale={i18nConfig.locale}
        messages={i18nConfig.messages}>
        <Provider state={ state } actions={ actions }>
          <AppContainer>
            <AppComponent { ...props } />
          </AppContainer>
        </Provider>
      </IntlProvider>,
      document.getElementById(mountId)
    )
  })
}

let useApps = {}
let prevState = {}

const startApps = async (mountApps = {}) => {
  useApps = mountApps

  config = await (await fetch('/app.config.json')).json()

  settings.setupLocale(config.supportedLocales)

  i18nConfig = await (await fetch(`${settings.localeURL}${config.locale_json_URL}`, {
    method: 'get',
    credentials: 'same-origin'
  })).json()


  if( Object.keys(useApps).length === 0 ) {
    console.warn('You tried to mount React apps without specifying any apps! Mounting nothing. I hope you\'re happy.')
    return false
  }

  const hydrateKeys = {
    selectedOptions: null,
    _craneData: [],
    defaultStandard: i18nConfig.standard
  }

  const persistedState = await mux(reduce(hydrateKeys, (all, val, key) => {
    all[ key ] = storage(key).get(val)
    return all
  }, {}))

  let { state, actions } = await createStore(await stores(useApps), merge({}, persistedState, { _activeApps: useApps }))
  prevState = state

  renderActiveApps(state._activeApps, appConfig, state, actions)
}

invoke(window, 'onGatewayAppsLoaded', startApps)

if( module.hot ) {
  async function onHmr() {
    const nextStores = require('./stores').default
    const nextApps = require('./apps').default

    const { state, actions } = await createStore(await nextStores(useApps), toJS(prevState))
    prevState = state

    renderActiveApps(state._activeApps, nextApps, state, actions)
  }

  module.hot.accept('./stores', onHmr)
}
